import * as PIXI from "pixi.js";
import { Multiplier } from "./Multiplier";
import { ScatterParticle } from "./ScatterParticle";
import { delay } from "src/shared/util/UtilFunctions";
import gsap from "gsap";
import { soundManager } from "./shared/UI/SoundManager";

export class MultiplierPanel extends PIXI.Container {
    private multipliers: Multiplier[] = [];
    private scattersCollected: number = 0;
    private currentMultiplierIndex: number = 0;
    private winLayer: PIXI.Graphics;
    private wildText: PIXI.Text;
    private scatterParticle: ScatterParticle;

    constructor() {
        super();

        this.winLayer = new PIXI.Graphics().rect(-2000, -2000,
            4000, 4000).fill(0);
        this.winLayer.alpha = 0.7;
        this.winLayer.visible = false;
        this.addChild(this.winLayer);

        this.scatterParticle = ScatterParticle.pool.acquire();
        this.scatterParticle.visible = false;
        this.scatterParticle.scale.set(2);
        this.addChild(this.scatterParticle);

        this.wildText = new PIXI.Text({
            text: "Random Wilds!",
            style: {
                fontSize: 50,
                align: 'center',
                fontFamily: "TextFont",
                fill: "0xfad035",
                stroke: { color: '0x4a1850', width: 4, join: 'round' },
            }
        });
        this.wildText.anchor.set(0.5);
        this.wildText.position.set(0, 130);
        this.wildText.visible = false;
        this.addChild(this.wildText);

        const multipliers = [1, 2, 3, 5, 20];
        multipliers.forEach((multiplier, index) => {
            const mult = new Multiplier(multiplier, index < 3 ? 3 : 4);
            mult.x = (index - 2) * 150;
            mult.y = 430;
            this.addChild(mult);
            this.multipliers.push(mult);
        })
    }

    _collect(amount: number) {
        while (amount && this.multipliers[this.currentMultiplierIndex]) {
            this.multipliers[this.currentMultiplierIndex].collect()
            if (this.multipliers[this.currentMultiplierIndex].isFull()) {
                this.currentMultiplierIndex++;
            }
            amount--;
        }
    }

    isFull() {
        return this.currentMultiplierIndex >= this.multipliers.length;
    }

    collect(scattersCollected: number) {
        this._collect(scattersCollected - this.scattersCollected)
        this.scattersCollected = scattersCollected;
    }

    collectOne() {
        this.scattersCollected++;
        this._collect(1);
        soundManager.playSound("collectBonus");
    }

    async turnOnMain(multiplier: number) {
        const multiplierObj = this._getMultipier(multiplier);
        if (multiplierObj) {
            this.scatterParticle.position.set(0, 0);
            this.scatterParticle.visible = true;
            this.scatterParticle.reset();
            this.winLayer.visible = true;
            this.wildText.visible = true;
            this.visible = true;
            this.alpha = 0;
            gsap.to(this, {
                duration: 0.2,
                alpha: 1,
            });
            await delay(1700);
            await this.scatterParticle.collect(multiplierObj.x, multiplierObj.y);
            this.turnOn(multiplier);
            this.scatterParticle.visible = false;
            this.winLayer.visible = false;
            this.wildText.visible = false;
        }
    }

    _getMultipier(multiplier: number) {
        switch (multiplier) {
            case 1:
                return this.multipliers[0];
            case 2:
                return this.multipliers[1];
            case 3:
                return this.multipliers[2];
            case 5:
                return this.multipliers[3];
            case 20:
                return this.multipliers[4];
        }
    }

    turnOn(multiplier: number) {
        const multiplierObj = this._getMultipier(multiplier);
        if (multiplierObj) {
            multiplierObj.turnOn();
        }
    }

    hideCollector() {
        this.multipliers.forEach((multiplier) => {
            multiplier.hideCollector();
        })
    }

    showCollector() {
        this.scattersCollected = 0;
        this.currentMultiplierIndex = 0;
        this.multipliers.forEach((multiplier) => {
            multiplier.showCollector();
        })
    }

    turnOff() {
        this.multipliers.forEach(mult => mult.turnOff());
    }

    getFireGlobalPosition() {
        return this.multipliers[this.currentMultiplierIndex].getFireGlobalPosition();
    }
}
